import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

// Async thunks
export const fetchLanguages = createAsyncThunk(
  "language/fetchLanguages",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/languages");
      const data = response.data?.data || response.data;
      return Array.isArray(data?.languages)
        ? data.languages
        : Array.isArray(data)
        ? data
        : [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch languages"
      );
    }
  }
);

export const createLanguage = createAsyncThunk(
  "language/createLanguage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("/admin/languages", data);
      const responseData = response.data?.data || response.data;
      return responseData?.language || responseData;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create language"
      );
    }
  }
);

export const updateLanguage = createAsyncThunk(
  "language/updateLanguage",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/admin/languages/${id}`, data);
      const responseData = response.data?.data || response.data;
      return responseData?.language || responseData;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update language"
      );
    }
  }
);

export const deleteLanguage = createAsyncThunk(
  "language/deleteLanguage",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/admin/languages/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete language"
      );
    }
  }
);

const languageSlice = createSlice({
  name: "language",
  initialState: {
    languages: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLanguages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLanguages.fulfilled, (state, action) => {
        state.loading = false;
        state.languages = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchLanguages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createLanguage.fulfilled, (state, action) => {
        state.languages.push(action.payload);
      })
      .addCase(updateLanguage.fulfilled, (state, action) => {
        const index = state.languages.findIndex(
          (lang) => lang.id === action.payload.id
        );
        if (index !== -1) {
          state.languages[index] = action.payload;
        }
      })
      .addCase(deleteLanguage.fulfilled, (state, action) => {
        state.languages = state.languages.filter(
          (lang) => lang.id !== action.payload
        );
      });
  },
});

export const { clearError } = languageSlice.actions;
export default languageSlice.reducer;
